import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const AlertModal = ({ open, onClose, message, data }) => {
  const navigate = useNavigate();
  return (
    <div>
      <Dialog open={open} onClose={onClose} maxWidth="2xl">
        <DialogTitle className="font-bold uppercase">{message}</DialogTitle>
        <hr />
        <DialogContent>
          <div>
            <table>
              <thead>
                <tr className="border-b border-app-border">
                  <th className="text-left border-r p-2 ">SN</th>
                  <th className="text-left border-r p-2 ">Name</th>
                  <th className="text-left border-r p-2 ">Email</th>
                  <th className="text-left border-r p-2 ">USI Number</th>
                  <th className="text-left border-r p-2 ">Status</th>
                  <th className="text-left border-r p-2 ">Certification Type</th>
                  <th className="text-left border-r p-2 ">Case Officer</th>
                  <th className="text-left border-r p-2 ">Action</th>
                </tr>
              </thead>

              {data?.map((item, index) => (
                <tr className="border-b border-app-border p-2" key={item?.id}>
                  <td className="border-r p-2">{index + 1}</td>
                  <td className="border-r p-2">{item?.name}</td>
                  <td className="border-r p-2">{item?.email}</td>
                  <td className="border-r p-2">{item?.usiNumber}</td>
                  <td className="border-r p-2">{item?.status}</td>
                  <td className="border-r p-2">{item?.certificate}</td>
                  <td className="border-r p-2">{item?.caseOfficer}</td>
                  <td className="border-r p-2">
                    <Button
                      onClick={() => {
                        navigate(`/admin/rpl-client/edit/${item?.id}`, {
                          state: { item },
                        });
                        onClose();
                      }}
                      variant="outlined"
                      color="primary"
                    >
                      View Details
                    </Button>
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </DialogContent>
        <hr />
        <DialogActions>
          <Button onClick={onClose} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertModal;
